<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Nyomtatványok</span>
      <el-button
        v-can="['representativeform.create']"
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/representative-processes/representative-forms/add')"
        icon="el-icon-plus"
      >
        Új nyomtatvány
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="representativeForm/fetchAll"
      />
    </div>
    <representative-form-list />
    <template v-if="$route.meta.showAddRepresentativeFormDialog">
      <representative-form-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateRepresentativeFormDialog">
      <representative-form-dialog
        :representative-form-id="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
  import representativeFormList from '../../components/representativeProcesses/representativeForms/List';
  import representativeFormDialog from '../../components/representativeProcesses/representativeForms/Dialog';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      representativeFormList,
      representativeFormDialog,
      TableFilter,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    mounted() {
      this.loading = true;
      this.setConfig();
      this.loading = false;
    },
    methods: {
      setConfig() {
        this.filterConfig = [
          {
            type: 'text',
            name: 'name',
            label: 'Nyomtatvány neve',
            defaultSearch: true,
          },
          {
            type: 'select',
            options: [
              {
                label: 'Aktív',
                is_active: '1'
              },
              {
                label: 'Inaktív',
                is_active: '0'
              },
            ],
            name: 'is_active',
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'is_active',
          }
        ];
      },
    },
  };
</script>
